/* eslint-disable react/jsx-no-useless-fragment */
import { Loader2Icon } from 'lucide-react';
import React from 'react';

import { cn } from '@/utils';

interface WithLoadingProps {
	isLoading?: boolean;
	children?: React.ReactNode;
	className?: string;
}

const WithLoading = (props: WithLoadingProps) => {
	const { isLoading = true, className, children } = props;

	if (isLoading) {
		return <Loader2Icon className={cn('animate-spin', className)} />;
	}

	return <>{children}</>;
};

export { WithLoading };
